export default __webpack_public_path__ + "4d49e96624c12b9fd5753bc5d27f52b6.svg";